import React, { useEffect, useState } from "react";
import { getTodayAssignedComplaintNotifications } from "../../../services/AgentServices"; 
const Notifications = () => {
  const [agentNotifications, setAgentNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAgentNotifications = async () => {
      try {
        const response = await getTodayAssignedComplaintNotifications();
        if (response.status && response.agent_notification) {
          setAgentNotifications(response.agent_notification);
        } else {
          setAgentNotifications([]);
        }
      } catch (error) {
        console.error("Error fetching agent notifications:", error);
        setAgentNotifications([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAgentNotifications();
  }, []);

  return (
    <div className="container my-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">📢 Assigned Tickets</h5>
        </div>
        <div className="card-body">
          {loading ? (
            <p>Loading...</p>
          ) : agentNotifications.length === 0 ? (
            <p className="text-muted">No Tickets Assigned.</p>
          ) : (
            <ul className="list-group">
              {agentNotifications.map((message, index) => (
                <li key={index} className="list-group-item">
                  {message}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Notifications;
